import { PaginatedTable } from '../PaginatedTable/PaginatedTable';

import { LuBaby } from "react-icons/lu";
import { OfficialFormatDateWithYear } from '../../utilities/FormatDate';
import { useNavigate, useParams } from 'react-router-dom';
import { ExportFeedingSessionCSV } from '../Buttons/ExportFeedingSessionCSV';
import { ExportAllFeedingsZip } from '../Buttons/ExportAllFeedingsZip';
import { ExportBiomarkersCSV } from '../Buttons/ExportBiomarkersCSV';
import { CalculateBiomarkersButton } from '../Buttons/CalculateBiomarkersButton';
import { FaRegHospital } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { CustomBiomarkerButton } from '../Buttons/CustomBiomarkerButton';


function FeedingsTable(props) {

  const { name: facility_name } = useParams();

  const navigate = useNavigate();

  const feedingsColumns = [
    {
      name: <input type="checkbox" 
        checked={props.selectedFeedings.length === props.data.length}
        onChange={() => props.selectedFeedings.length === props.data.length ? props.deselectAllFeedings() : props.selectAllFeedings()}/>,
      selector: row => <input type="checkbox" checked={props.selectedFeedings.includes(row.timestamp)} onChange={() => props.changeFeedingSelection(row.timestamp)}/>,
      width: '50px'
    },
    {
      name: 'Date',
      selector: row => OfficialFormatDateWithYear( row.timestamp ),
      sortable: true,
    },
    {
      name: 'Conceptual Age (Weeks)',
      selector: row => row.calculate_age,
      sortable: true,
    },
    {
      name: 'Feed Duration',
      selector: row => row.duration,
      sortable: true
    },
    {
      name: 'Biomarkers',
      selector: row => row.has_biomarkers ? 'Yes' : 'No',
      sortable: true
    },
    {
      name: '',
      selector: (row) => <ExportFeedingSessionCSV feeding={row} patient={props.patient}/>,
      width: '100px'
    }
  ];

  return (
    <PaginatedTable
      name={facility_name 
        ? (
          <>
            <span onClick={() => navigate(-2)} style={{ cursor: "pointer",}}>Facilities</span>
            { " / "}
            <span>{facility_name}</span>
            { " / "}
            <span onClick={() => navigate(-1)} style={{ cursor: "pointer",}}>Patients</span>
            { " / " }
            <span>{props.patient.name}(ID:{props.patient.ehr_patient_ref})</span>
          </>) 
        : 'Patients'}
      icon={facility_name ? <FaRegHospital size={25} /> : <LuBaby size={25} />}
      data={props.data}
      columns={feedingsColumns}
      specialButton={
        <>
          { props.selectedFeedings.length !== 0 && <CustomBiomarkerButton selectedFeedings={props.selectedFeedings} patient={props.patient}/>}
          <div className='small-spacer'></div>
          <CalculateBiomarkersButton patient_id={props.patient.patient_id} feedings={props.patient.feedings}/>
          <div className='small-spacer'></div>
          <ExportBiomarkersCSV patient_id={props.patient.patient_id} />
          <div className='small-spacer'></div>
          <ExportAllFeedingsZip patient={props.patient} feedings={props.patient.feedings}/> 
        </>
        
      } />
  )
}

export default FeedingsTable;